// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6420":"5174f8dd","7182":"fdc70f30","7907":"935459cc","8148":"89927715","9396":"15706fc5"}[chunkId] + ".chunk.css";
};